// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import CheckoutController from "./checkout_controller"
application.register("checkout", CheckoutController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DaterangepickerController from "./daterangepicker_controller"
application.register("daterangepicker", DaterangepickerController)

import DynamicDatesController from "./dynamic_dates_controller"
application.register("dynamic-dates", DynamicDatesController)

import DynamicFieldsController from "./dynamic_fields_controller"
application.register("dynamic-fields", DynamicFieldsController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import RevenueChartController from "./revenue_chart_controller"
application.register("revenue-chart", RevenueChartController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TrainingSessionFormController from "./training_session_form_controller"
application.register("training-session-form", TrainingSessionFormController)
